import isProduction from "Utils/isProduction";

export const IndividualLifeEligible = (employeeForm) => {
  const employeeAge = employeeForm.age;

  return employeeAge >= 20 && employeeAge <= 60 && !employeeForm.hideIndividualApplications;
};
